import { Input, Table, TableProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import Title from 'antd/lib/typography/Title';

interface TopMerchantsTypes {
  key: string;
  merchant: string;
  total_amount: number;
  transactions: number;
  location: string;
}

const columns: TableProps<TopMerchantsTypes>['columns'] = [
  {
    title: 'Comercio',
    dataIndex: 'merchant',
    render: (text) => <a>{text}</a>,
  },
  {
    title: 'Total operado',
    className: 'total_amount',
    dataIndex: 'total_amount',
    align: 'right',
    render: (money) =>
      new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
      }).format(money),
  },
  {
    title: 'Transacciones',
    dataIndex: 'transactions',
  },
  {
    title: 'Ubicación',
    dataIndex: 'location',
  },
];

const TopMerchantsTable = ({ topMerchantsData, loadingTopMerchants }) => {
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<TopMerchantsTypes[]>(topMerchantsData);

  useEffect(() => {
    const filtered = topMerchantsData?.filter((item) =>
      item.merchant.toLowerCase().includes(searchText.toLowerCase()) ||
      item.location.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, topMerchantsData]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <Table<TopMerchantsTypes>
      columns={columns}
      dataSource={filteredData}
      loading={loadingTopMerchants}
      rowKey="key"
      title={() => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={3} style={{ margin: 0 }}>Top merchants</Title>
          <Input
            className="custom-search-input"
            placeholder="Buscar por comercio..."
            prefix={<SearchOutlined style={{ color: '#6950E8' }} />}
            value={searchText}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
        </div>
      )}
    />
  );
};

export default TopMerchantsTable;